import React from 'react';
import classnames from 'classnames';
import { Tooltip } from 'swag-client-common/components/info/tooltip/tooltip';
import Color from 'swag-client-common/components/ui/color';
import { SinglePantonePicker } from 'swag-client-common/components/pickers/single-pantone-picker';
import { Placement } from 'swag-client-common/constants';
import crossImage from 'assets/svg/delete_icon.svg';
import { isWhiteByHex } from 'swag-client-common/utils/is-white-color';
import classes from './pantone-color-picker-extended.scss';
export const PantoneColorPickerExtended = ({
  colors,
  addColorEnabled,
  removeColorEnabled,
  isLimitedEdition = false,
  className,
  onColorRemove,
  onColorAdd,
  hasColors,
  colorClassName = '',
  isStaticColorSize = false
}) => /*#__PURE__*/React.createElement("div", {
  className: classnames(className)
}, hasColors ? colors.map((pantoneColor, index) => {
  const pantoneDetected = !!pantoneColor.hex;
  return /*#__PURE__*/React.createElement("div", {
    key: index,
    className: classnames(classes.colorRow, isStaticColorSize ? classes.staticSize : '')
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.colorInfo
  }, pantoneDetected && /*#__PURE__*/React.createElement(Color, {
    color: pantoneColor.hex,
    className: classnames(classes.color, isWhiteByHex(pantoneColor === null || pantoneColor === void 0 ? void 0 : pantoneColor.hex) && classes.whiteColor, colorClassName ? colorClassName : ''),
    badgeClassName: classes.badgeColor
  }), /*#__PURE__*/React.createElement(Tooltip, {
    title: pantoneColor.pms,
    placement: Placement.TOP,
    className: classnames(classes.pantoneColorTooltip, {
      [classes.orangePantone]: isLimitedEdition
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.pantoneColor
  }, pantoneColor.pms))), removeColorEnabled && /*#__PURE__*/React.createElement("img", {
    "data-name": "remove-color",
    "data-color": pantoneColor.pms,
    "data-tooltip": 'Remove color from print list',
    onClick: () => onColorRemove(pantoneColor.pms),
    src: crossImage,
    className: classes.removeIcon
  }));
}) : null, addColorEnabled && /*#__PURE__*/React.createElement(SinglePantonePicker, {
  isLimitedEdition: isLimitedEdition,
  onSubmit: onColorAdd,
  buttonText: "Add",
  className: classes.singlePantoneInput,
  labelText: "Add Color",
  placeholder: "Input exact Pantone color",
  text: ""
}));